import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PlacetypesService } from 'src/app/services/core/placetypes/placetypes.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-add-placetypes',
  templateUrl: './add-placetypes.component.html',
  styleUrls: ['./add-placetypes.component.css']
})
export class AddPlacetypesComponent implements OnInit {
  placeTypeForm!: FormGroup;
  placeTypeId :any;
  submitted = false;

  // Edit Modal Inputs and Outputs
  @Input() placeType: any;
  @Input() source: any;
  @Output() onSavePlaceType = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  // Edit Modal Inputs and Outputs End


  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router,private placetypesService: PlacetypesService){

  }

  ngOnInit(){
    if (this.source === 'modal' && this.placeType) {
      this.placeTypeId = this.placeType.id;
      this.getPlaceTypeById();
    } else {
      this.placeTypeId = this.route.snapshot.params['place-types'];
      if (this.placeTypeId) {
        this.getPlaceTypeById();
      }
    }

    this.placeTypeForm = this.fb.group({
      title: ['', Validators.required],
      isActive: [true, Validators.required],
      description: ['', Validators.required]
    })
  }

  get form(){
    return this.placeTypeForm.controls;
  }

  onSave(){
    this.submitted = true;
    if(this.placeTypeForm.invalid)
      return;

    const payload = this.placeTypeForm.value;

    this.placetypesService.savePlaceType(this.placeTypeId, payload).pipe(untilDestroyed(this)).subscribe((data: any) =>{
      if(data){
        if (this.source === 'modal') {
          this.onSavePlaceType.emit(data);
        } else {
          this.router.navigateByUrl('/configurations/place-types');

        }
      }
    },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
  )
  }

  getPlaceTypeById(){
    this.placetypesService.getPlaceTypeById(this.placeTypeId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.placeTypeForm.patchValue({
          ...data
        });
      }
    })
  }
}
